import React, { Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ListProvidersPage from './list-providers-page';
import AddProviderPage from './add-provider-page';
import EditProviderPage from './edit-provider-page';

const ProvidersRoutingPages = ({ match }) => (
  <Suspense fallback={<div className="loading" />}>
    <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />

        <Route path={`${match.url}/list`}
          render={props => <ListProvidersPage {...props} />}
        />

        <Route path={`${match.url}/add-new`}
          render={props => <AddProviderPage {...props} />}
        />

        <Route path={`${match.url}/edit/:providerId`}
          render={props => <EditProviderPage {...props} />}
        />

        <Redirect from={`${match.url}/`} to={`${match.url}/list`} />
        <Redirect to="/error" />
      </Switch>
    
  </Suspense>
);
export default ProvidersRoutingPages;
